import type { NextPage } from 'next'
import HomePage from './homepage.page'

const Index: NextPage = () => {
  return <HomePage />
}

export default Index
